export default {
  GET_STATISTICS_RAIN: 'GET_STATISTICS_RAIN',
  GET_ADCD: 'GET_ADCD',
  GET_STATISTICS_RESERVOIR_WATER: 'GET_STATISTICS_RESERVOIR_WATER',
  GET_STATISTICS_RIVER_WATER: 'GET_STATISTICS_RIVER_WATER',
  GET_HOURLY_RAINFALL_INFO: 'GET_HOURLY_RAINFALL_INFO',
  GET_DAILY_RAINFALL_INFO: 'GET_DAILY_RAINFALL_INFO',
  GET_MONTHLY_RAINFALL: 'GET_MONTHLY_RAINFALL',
  GET_SYNTHETICAL_WATERANDRAIN: 'GET_SYNTHETICAL_WATERANDRAIN',
  GET_SYNTHETICAL_RAIN: 'GET_SYNTHETICAL_RAIN',
  GET_YEARLY_RAINFALL: 'GET_YEARLY_RAINFALL',
  GET_VIDEOMONITOR_URL: 'GET_VIDEOMONITOR_URL',
  GET_MONITOR_STATIONS: 'GET_MONITOR_STATIONS',
  // 导出
  EXPORT_REALTIME_RAIN: 'EXPORT_REALTIME_RAIN',
  EXPORT_RIVER_WATER: 'EXPORT_RIVER_WATER',
  EXPORT_RESERVOIR_WATER: 'EXPORT_RESERVOIR_WATER',
  EXPORT_RAINSTATIS_HOURLY: 'EXPORT_RAINSTATIS_HOURLY',
  EXPORT_RAINSTATIS_DAILY: 'EXPORT_RAINSTATIS_DAILY',
  EXPORT_RAINSTATIS_MONTHLY: 'EXPORT_RAINSTATIS_MONTHLY',
  EXPORT_RAINSTATIS_YEARLY: 'EXPORT_RAINSTATIS_YEARLY',
  // 全区降雨量导出
  EXPORT_ALLRAINFALL: 'EXPORT_ALLRAINFALL',
  // 获取测站详情
  GET_RAIN_WATER_TOTAL: 'GET_RAIN_WATER_TOTAL',
  GET_RAINWATERMINUTESTOTAL: 'GET_RAINWATERMINUTESTOTAL',
  // 获取全区降雨量统计信息
  GET_ALLRAINFALL: 'GET_ALLRAINFALL',
  GET_RAIN_WATER_REPORT: 'GET_RAIN_WATER_REPORT',
  GET_RAIN_WATER_REPORT_EXPORT: 'GET_RAIN_WATER_REPORT_EXPORT'
}
